export default __webpack_public_path__ + "static/media/screen7.11106359.png";